import { render, staticRenderFns } from "./embed-snippet.vue?vue&type=template&id=0beb4948&scoped=true"
import script from "./embed-snippet.vue?vue&type=script&lang=js"
export * from "./embed-snippet.vue?vue&type=script&lang=js"
import style0 from "./embed-snippet.vue?vue&type=style&index=0&id=0beb4948&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb4948",
  null
  
)

export default component.exports